module.exports = __webpack_public_path__ + "img/1478434085.99da128b.jpg";